/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bookings_Meta_TitleInputs */

const en_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Bookings | Mark Egly Golf`)
};

const es_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis reservas | Mark Egly Golf`)
};

const de_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Buchungen | Mark Egly Golf`)
};

const zh_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的预订 | Mark Egly Golf`)
};

const ar_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجوزاتي | Mark Egly Golf`)
};

const fr_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes réservations | Mark Egly Golf`)
};

const vi_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt chỗ của tôi | Mark Egly Golf`)
};

const sw_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi Zangu | Mark Egly Golf`)
};

const th_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การจองของฉัน | Mark Egly Golf`)
};

const bs_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezervacije | Mark Egly Golf`)
};

const ja_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイ予約 | Mark Egly Golf`)
};

const ko_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 예약 | Mark Egly Golf`)
};

const pt_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas reservas | Mark Egly Golf`)
};

const it_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie prenotazioni | Mark Egly Golf`)
};

const sv_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina bokningar | Mark Egly Golf`)
};

const nl_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn boekingen | Mark Egly Golf`)
};

const da_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine bookinger | Mark Egly Golf`)
};

const nb_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine bestillinger | Mark Egly Golf`)
};

const fi_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaukseni | Mark Egly Golf`)
};

const pl_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezerwacje | Mark Egly Golf`)
};

const ru_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои бронирования | Mark Egly Golf`)
};

const tr_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyonlarım | Mark Egly Golf`)
};

const hi_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरी बुकिंग | Mark Egly Golf`)
};

const id_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan Saya | Mark Egly Golf`)
};

const ms_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempahan Saya | Mark Egly Golf`)
};

const cs_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezervace | Mark Egly Golf`)
};

const el_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι κρατήσεις μου | Mark Egly Golf`)
};

const he_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההזמנות שלי | Mark Egly Golf`)
};

const af_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My besprekings | Mark Egly Golf`)
};

const hu_bookings_meta_title = /** @type {(inputs: Bookings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalásaim | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "My Bookings \| Mark Egly Golf" |
*
* @param {Bookings_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const bookings_meta_title = /** @type {((inputs?: Bookings_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bookings_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_bookings_meta_title(inputs)
	if (locale === "de") return de_bookings_meta_title(inputs)
	if (locale === "zh") return zh_bookings_meta_title(inputs)
	if (locale === "ar") return ar_bookings_meta_title(inputs)
	if (locale === "fr") return fr_bookings_meta_title(inputs)
	if (locale === "vi") return vi_bookings_meta_title(inputs)
	if (locale === "sw") return sw_bookings_meta_title(inputs)
	if (locale === "th") return th_bookings_meta_title(inputs)
	if (locale === "bs") return bs_bookings_meta_title(inputs)
	if (locale === "ja") return ja_bookings_meta_title(inputs)
	if (locale === "ko") return ko_bookings_meta_title(inputs)
	if (locale === "pt") return pt_bookings_meta_title(inputs)
	if (locale === "it") return it_bookings_meta_title(inputs)
	if (locale === "sv") return sv_bookings_meta_title(inputs)
	if (locale === "nl") return nl_bookings_meta_title(inputs)
	if (locale === "da") return da_bookings_meta_title(inputs)
	if (locale === "nb") return nb_bookings_meta_title(inputs)
	if (locale === "fi") return fi_bookings_meta_title(inputs)
	if (locale === "pl") return pl_bookings_meta_title(inputs)
	if (locale === "ru") return ru_bookings_meta_title(inputs)
	if (locale === "tr") return tr_bookings_meta_title(inputs)
	if (locale === "hi") return hi_bookings_meta_title(inputs)
	if (locale === "id") return id_bookings_meta_title(inputs)
	if (locale === "ms") return ms_bookings_meta_title(inputs)
	if (locale === "cs") return cs_bookings_meta_title(inputs)
	if (locale === "el") return el_bookings_meta_title(inputs)
	if (locale === "he") return he_bookings_meta_title(inputs)
	if (locale === "af") return af_bookings_meta_title(inputs)
	if (locale === "hu") return hu_bookings_meta_title(inputs)
	return en_bookings_meta_title(inputs)
});